import * as _ from 'underscore';

import { DatasourceSubspaceName } from '../../state/SpaceInfo';

export namespace DatasourceSpaceConfigHelper {

  export interface DatasourceSubspace {
    name: DatasourceSubspaceName;
    urlSuffix: string;
  }

  export const DatasourceSubspaces: DatasourceSubspace[] = [
    {
      name: 'nlp',
      urlSuffix: 'askData',
    },
    {
      name: 'connections',
      urlSuffix: 'connections',
    },
    {
      name: 'extractRefreshes',
      urlSuffix: 'extractRefreshes',
    },
    {
      name: 'remoteRefreshSchedules',
      urlSuffix: 'localExtractRefreshes',
    },
    {
      name: 'connectedWorkbooks',
      urlSuffix: 'connectedWorkbooks',
    },
    {
      name: 'lineage',
      urlSuffix: 'lineage',
    },
    {
      name: 'askDataUsageAnalytics',
      urlSuffix: 'askDataUsageAnalytics',
    },
  ];

  export function urlSuffixFromSubspaceName(subspaceName: DatasourceSubspaceName): string | undefined {
    const subspace = _(DatasourceSubspaces).findWhere({ name: subspaceName });
    return subspace && subspace.urlSuffix || undefined;
  }
}
